<div class="card vx-shadow-hover text-center h-100">
  <div class="card-body p-0 bluebackground">
    <h2 class="card-title small my-2 h5">RDOF Flyer</h2>
    <div class="pdfimg-container">
      <img class="img-fluid mb-1 mx-auto pdfimg" ngSrc="assets/images/sidebar/RDOF.webp" alt="" width="500" height="647" loading="lazy">
    </div>
  </div>
  <div class="card-footer p-2 border-0 bluebackground">
    <div class="text-center btn-green w-100"><a queryParamsHandling="merge" class="py-2 text-white vx-cursor stretched-link" href="assets/uploads/sidebardownload/D08-00-092_RDOF_Flyer_FINAL.pdf" target="_blank">Download a Copy</a>
    </div>
  </div>
</div>
